const SMTP2GO_API_URL = "https://api.smtp2go.com/v3/email/send";
const SMTP2GO_API_KEY = import.meta.env.VITE_SMTP2GO_API_KEY;
const SMTP2GO_SENDER = import.meta.env.VITE_SMTP2GO_SENDER;

export async function sendEmail({ to, subject, htmlBody, textBody }) {
  const res = await fetch(SMTP2GO_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify({
      api_key: SMTP2GO_API_KEY,
      sender: SMTP2GO_SENDER,
      to: Array.isArray(to) ? to : [to],
      subject,
      html_body: htmlBody,
      text_body: textBody,
    }),
  });

  const data = await res.json();

  if (!res.ok || data?.data?.failed) {
    throw new Error(data?.data?.error || `SMTP2GO error: ${res.status}`);
  }

  return data;
}
